import {
    getCharMinMessage,
    getReqMessage,
    getSelectMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const MIN_COURSE_NAME = 5;
export const MIN_COURSE_DESCRIPTION = 50;
export const MIN_MODULES = 2;
export const MODULAR_COURSES_ERROR = `Modular courses must contain at least ${MIN_MODULES} modules.`;

export const MIN_MODULE_NAME = 15;
export const MIN_MODULE_DESCRIPTION = 50;
export const MIN_ACTION_NAME = 15;
export const MIN_ACTION_DESCRIPTION = 50;
export const UNIQUE_MODULE_NAME_ERROR = 'Module names must be unique within a course template.';
export const MODULAR_SESSIONS_ERROR = 'One or more modules require session data input.';
export const MAX_ACTION_DESCRIPTION = 750;
export const MAX_MODULE_DESCRIPTION = 250;
export const MAX_COURSE_DESCRIPTION = 250;

export const validateCourseName = (name, errors) => {
    if (!name.trim().length) {
        return {
            ...errors,
            name: { error: true, message: getReqMessage('Course name') }
        };
    } else if (name.trim().length < MIN_COURSE_NAME) {
        return {
            ...errors,
            name: { error: true, message: getCharMinMessage('Course name', MIN_COURSE_NAME) }
        };
    }
    return errors;
};

export const validateCourseDescription = (description, errors) => {
    if (!description.trim().length) {
        return {
            ...errors,
            description: { error: true, message: getReqMessage('Course description') }
        };
    } else if (description.trim().length < MIN_COURSE_DESCRIPTION) {
        return {
            ...errors,
            description: {
                error: true,
                message: getCharMinMessage('Course description', MIN_COURSE_DESCRIPTION)
            }
        };
    }
    return errors;
};

export const validateModuleName = (name, errors) => {
    if (!name) {
        return {
            ...errors,
            moduleName: { error: true, message: getReqMessage('Module name') }
        };
    } else if (name.trim().length < MIN_MODULE_NAME) {
        return {
            ...errors,
            moduleName: { error: true, message: getCharMinMessage('Module name', MIN_MODULE_NAME) }
        };
    }
    return errors;
};

export const validateModuleDescription = (description, errors) => {
    if (!description) {
        return {
            ...errors,
            moduleDescription: { error: true, message: getReqMessage('Module description') }
        };
    } else if (description.trim().length < MIN_MODULE_DESCRIPTION) {
        return {
            ...errors,
            moduleDescription: {
                error: true,
                message: getCharMinMessage('Module description', MIN_MODULE_DESCRIPTION)
            }
        };
    }
    return errors;
};

export const validateSmartTargetName = (name, errors) => {
    if (!name) {
        return {
            ...errors,
            smartTargetActionName: { error: true, message: getReqMessage('Action name') }
        };
    } else if (name.trim().length < MIN_ACTION_NAME) {
        return {
            ...errors,
            smartTargetActionName: {
                error: true,
                message: getCharMinMessage('Action name', MIN_ACTION_NAME)
            }
        };
    }
    return errors;
};

export const validateSmartTargetAction = (action, errors) => {
    if (!action) {
        return {
            ...errors,
            smartTargetActionDescription: {
                error: true,
                message: getReqMessage('Action description')
            }
        };
    } else if (action.trim().length < MIN_ACTION_DESCRIPTION) {
        return {
            ...errors,
            smartTargetActionDescription: {
                error: true,
                message: getCharMinMessage('Action description', MIN_ACTION_DESCRIPTION)
            }
        };
    }
    return errors;
};

export const validateBarrierNameId = (barrierNameId, errors) => {
    if (!barrierNameId) {
        return {
            ...errors,
            smartTargetBarrierNameId: { error: true, message: getSelectMessage('barrier name') }
        };
    }
    return errors;
};

export const validateContractIds = (contractIds, errors) => {
    if (contractIds.length < 1) {
        return {
            ...errors,
            contractIds: { error: true, message: getSelectMessage('contract', 'at least one') }
        };
    }
    return errors;
};

export const validateHealthInformationIds = (healthInformationIds, errors) => {
    if (healthInformationIds.length < 1) {
        return {
            ...errors,
            healthInformationIds: {
                error: true,
                message: getSelectMessage('health condition', 'at least one')
            }
        };
    }
    return errors;
};

export const validateModuleTemplatesNumber = (moduleTemplates, errors) => {
    if (moduleTemplates.length < MIN_MODULES) {
        return {
            ...errors,
            modules: { error: true, message: MODULAR_COURSES_ERROR }
        };
    }
    return errors;
};

export const validateSessionNumber = (sessionNumber, errors) => {
    if (!+(sessionNumber)) {
        return {
            ...errors,
            sessionNumber: { error: true, message: getReqMessage('Session Number') }
        };
    }
    return errors;
};

export const validateDaysAfterPreviousModule = (days, errors) => {
    if (!+(days)) {
        return {
            ...errors,
            daysAfterPreviousModule: {
                error: true,
                message: getReqMessage('Days after Previous Module')
            }
        };
    }
    return errors;
};

export const validateUniqueNames = (moduleTemplates, errors) => {
    if (moduleTemplates.length < 2) return errors;
    const moduleNames = [...new Set(moduleTemplates.map((item) => item.name.trim().toLowerCase()))];
    if (moduleNames.length < moduleTemplates.length) {
        return {
            ...errors,
            modules: { error: true, message: UNIQUE_MODULE_NAME_ERROR }
        };
    }
    return errors;
};

export const validateModuleTemplateSessionData = (moduleTemplates, errors) => {
    if (moduleTemplates.some((el) => !el.sessionNumber)) {
        return {
            ...errors,
            modules: { error: true, message: MODULAR_SESSIONS_ERROR }
        };
    } else if (moduleTemplates.some((el) => el.sessionNumber > 1 && !el.daysAfterPreviousModule)) {
        return {
            ...errors,
            modules: { error: true, message: MODULAR_SESSIONS_ERROR }
        };
    }
    return errors;
};
